export const EMBEDDED_QUERY_PARAMETER: string = "?internal-embedded";
